'use client'

import React from 'react'

import { HTMLChakraProps, chakra } from '@chakra-ui/react'

export type PillProps = HTMLChakraProps<'span'>

const pillBaseStyles: HTMLChakraProps<'span'> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  p: '10px',
  borderRadius: 'full',
  fontSize: '12px',
  fontWeight: '500',
  lineHeight: '1',
  cursor: 'default',
}

export const Pill = ({ children, ...rest }: PillProps) => (
  <chakra.span {...pillBaseStyles} {...rest}>
    {children}
  </chakra.span>
)
